export function isDev(): boolean {
  return process.env.NODE_ENV !== "production";
}

export function isStaging(): boolean {
  return (
    process.env.NEXT_PUBLIC_SITE_ENV === "staging" ||
    process.env.SITE_ENV === "staging"
  );
}

export function getSiteUrl(): string {
  if (process.env.NEXT_PUBLIC_SITE_URL) {
    return process.env.NEXT_PUBLIC_SITE_URL;
  }

  if (isStaging()) {
    return "https://staging.captivateclick.com";
  }

  return "https://captivateclick.com";
}
